import {
  FETCH_UPCOMING_SESSIONS_REQUEST,
  FETCH_UPCOMING_SESSIONS_SUCCESS,
  FETCH_UPCOMING_SESSIONS_FAILURE,
  RESET_UPCOMING_SESSIONS
  
} from "./upcomingSessionTypes";
import { apiService } from "../../utils/apiRequest";
import store from "../store"; 


export const resetUpcomingSessions = () => ({
  type: RESET_UPCOMING_SESSIONS,
});
// Action to indicate the start of fetching upcoming sessions
export const fetchUpcomingSessionsRequest = () => ({
  type: FETCH_UPCOMING_SESSIONS_REQUEST,
});

// Action to handle successful fetch of upcoming sessions
export const fetchUpcomingSessionsSuccess = (upcomingSessions) => ({
  type: FETCH_UPCOMING_SESSIONS_SUCCESS,
  payload: upcomingSessions,
});

// Action to handle failure in fetching upcoming sessions
export const fetchUpcomingSessionsFailure = (error) => ({
  type: FETCH_UPCOMING_SESSIONS_FAILURE,
  payload: error,
});

// Thunk function to fetch upcoming sessions from the API
export const fetchUpcomingSessions = (franchiseProfile , page ,sessionstatus , filterdata , searchQuery  ) => async (dispatch) => {
  dispatch(fetchUpcomingSessionsRequest()); // Dispatch request action before API call

  try {
      // Construct API endpoint URL from environment variable
      const getUpcomingSessions = process.env.REACT_APP_API_URL + 'getUpcomingSessions';

      // Retrieve access token from Redux store
      const state = store.getState();
      const accessToken = state.auth.accessToken;

      // Check if the access token is available
      if (!accessToken) {
          throw new Error("Access token is missing. Please log in again.");
      }

      // Making API request to fetch upcoming sessions
      const response = await apiService(getUpcomingSessions, {
          method: "POST",
          headers: {
              Authorization: `Bearer ${accessToken}`, // Send authorization token
              "Content-Type": "application/json",
          },
          body: JSON.stringify({
              tutor_id: franchiseProfile.tutor_id,  
              franchise_id: franchiseProfile.franchise_id,
              page_number: page,
              page_size: 25,
              status: sessionstatus,
              appointment_type: String(filterdata?.appointment_type ?? ''),             
              session_type: filterdata?.session_type,
              student_id: filterdata?.student_id,
              job_id: filterdata?.job_id,
              subject: filterdata?.subject_id,
              search_text: searchQuery



          }),
      });

      // Dispatch success action with fetched data
      dispatch(fetchUpcomingSessionsSuccess(response));
  } catch (error) {
      console.error("Error fetching upcoming sessions:", error);
      dispatch(fetchUpcomingSessionsFailure(error.message)); // Dispatch failure action
  }
};
